import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../auth';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  login: number;
  password: string;
  passwordHide: boolean;

  constructor(private authService: AuthService, private router: Router) {
    this.passwordHide = true;
  }

  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.router.navigateByUrl('/');
    }
  }

  onClickLoginButton() {
    this.authService.login(this.login, this.password).subscribe(() => {
      this.router.navigateByUrl('/');
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onClickLoginButton();
    }
  }
}
